import { render, staticRenderFns } from "./Instagram.vue?vue&type=template&id=70aa657e"
import script from "./Instagram.vue?vue&type=script&lang=ts"
export * from "./Instagram.vue?vue&type=script&lang=ts"
import style0 from "./Instagram.vue?vue&type=style&index=0&id=70aa657e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports